<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="banco" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="nombre" :value="loadData.nombre"
             @change="(newNombreRol)=>$emit('updateValues', {'nombre': newNombreRol.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <p class="col-span-6 text-lg">
      <span class="font-semibold text-gray-700 mr-3"
      >Permisos:</span
      >
    </p>
    <div class="flex flex-wrap col-span-6 gap-6">
      <label v-for="(permiso, index) of loadDataPermisos"
             :for="'permiso' + index"
             :key="index"
             class="flex items-center grow px-4 border border-gray-200 rounded dark:border-gray-700">
             <!-- {{ permiso }} -->
        <input
            :checked="loadDataPermisos[index].checked"
            @change="()=>$emit('updateLoadDataPermisos', index)"
            :value="permiso.id"
            :id="'permiso' + index"
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        />
        <div class="py-4 ml-2 break-all text-sm font-medium text-gray-900 dark:text-gray-300">
          {{ permiso.permiso_nombre }}
        </div>
      </label>
    </div>
  </div>
</template>

<script>

/**
 * Componente que muestra el formulario para crear o actualizar un rol
 * @vue-prop {Object} loadData - Los datos presentes en el formulario.
 * @vue-prop {Array} loadDataPermisos - La lista de permisos con su respectivo estado.
 * @vue-event {Object} updateValues - Emite un objeto para actualizar una propiedad del componente padre.
 * @vue-event {number} updateLoadDataPermisos - Emite el índice de un checkbox cuyo estado ha cambiado.
 */
export default {
  name: 'RolesCrearActualizarComponent',
  props: {
    loadData: {
      type: Object,
      required: true,
    },
    loadDataPermisos: {
      type: Array,
      required: true,
    },
  },
  emits: ["updateValues", "updateLoadDataPermisos"],
}
</script>